/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Fab, IconButton, LinearProgress, Tab, Tabs, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button_circle from "src/shared/components/button_circle";
import { WrapMain } from "src/shared/modules/wrap_main";
import { ErrorComponent } from "src/shared/pages/error";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { loadLocationDetails } from "src/stateManagement/redux/slices/location/asyncReducers";
import DetallesDiagramaMecanico from "./diagramaMecanico/details/DetallesDiagramaMecanico";
import DiagramaMecanico from "./diagramaMecanico/DiagramaMecanico";
import { Requerimientos } from "./requerimientos/requerimientos";
import { AddRequirements } from "./requerimientos/add_requeriments/AddRequirements";
import { DinagraphiCards } from "./cartas_dinagraficas/DinagraphCards";
import { FluidLevels } from "./fluidLevels/FluidLevels";
import DetailsHeader from "./setpoints/wellSetpoints";
import { HistoricalActividades } from "./historical/HistoricalActividades";
import { Tags } from "./tags/Tags";
import { getLocations } from "src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { Trends } from "./tendencias";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { OptimizationActivities } from "./optimizationActivitiies/optimizationActivities";
import SubSurfaceJobs from "./tendencias/components/subSurfaceJob";
import WaterTest from "./tendencias/components/waterTest";
import { FileAttachment } from "./files/fileattachment";
import { ProductionModule } from "./production";
import { SteamModule } from "./steam";
import { TechnicalMeetDiscussions } from "./TechnicalMeetDiscussion";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const DetailsLocation = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [showDetailMechanical, setShowDetailMechanical] = useState(false);

    const { locationName, loading } = useSelector((state) => state.location);

    const [subSurfaceDataTable, setSubSurfaceDataTable] = useState<any[]>([]);

    useEffect(() => {
        dispatch(loadLocationDetails(id!));
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleGoToDashboard = () => {
        dispatch(getLocations(true));
        navigate("/gto/dashboard/2");
    };


    return (
        <WrapMain>
            {loading && (
                <>
                    <Box className="modal_analyst_loading_background" />
                    <Box className="modal__analyst_task_loading">
                        <LinearProgress />
                        Cargando....
                    </Box>
                </>
            )}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                }}
            >
                {/* Header Name */}
                <Box
                    className="history_task_container_header"
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 2,
                        padding: "10px 50px",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "white",
                    }}
                >
                    {/* return button */}
                    <Button variant="text" startIcon={<ArrowBackIcon />} onClick={() => handleGoToDashboard()}>
                        Volver
                    </Button>
                    {/* Location name */}
                    <Typography
                        variant="h2"
                        color="primary"
                        sx={{ fontWeight: "bold", fontSize: "26px" }}
                    >
                        {locationName}
                    </Typography>
                    <IconButton
                        size="medium"
                        color="primary"
                        onClick={() => { }}
                    >
                        <img src="/assets/icons/aliv2.svg" alt="icon" width={35} height={35} />
                    </IconButton>
                </Box>
                {/* Body tags */}
                <Box sx={{ width: "100%" }}>

                    <Grid
                        container
                        spacing={2}
                        sx={{ padding: "10px 50px" }}
                    >
                        <Grid size={12}>
                            <DetailsHeader />
                        </Grid>
                        {/* Tabs */}
                        <Grid size={12}>
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    scrollButtons="auto"
                                    variant="scrollable"
                                >
                                    <Tab
                                        label="Cartas Dinagráficas"
                                        {...a11yProps(0)}
                                    />
                                    <Tab
                                        label="Niveles de Fluidos"
                                        {...a11yProps(1)}
                                    />
                                    <Tab
                                        label="Tendencias"
                                        {...a11yProps(2)}
                                    />
                                    <Tab
                                        label="Diagramas Mecánicos"
                                        {...a11yProps(3)}
                                    />
                                    <Tab
                                        label="Historial de Actividades"
                                        {...a11yProps(4)}
                                    />
                                    <Tab
                                        label="Actividades de Optimización"
                                        {...a11yProps(5)}
                                    />
                                    <Tab
                                        label="Requerimientos"
                                        {...a11yProps(6)}
                                    />
                                    <Tab
                                        label="Trabajos de Subsuelo"
                                        {...a11yProps(7)}
                                    />
                                    <Tab
                                        label="Muestras de AyS"
                                        {...a11yProps(8)}
                                    />
                                    <Tab
                                        label="Producción"
                                        {...a11yProps(9)}
                                    />
                                    <Tab
                                        label="Ciclos de Vapor"
                                        {...a11yProps(10)}
                                    />
                                    <Tab
                                        label="Discusiones Técnicas"
                                        {...a11yProps(11)}
                                    />
                                    <Tab
                                        label="Archivos"
                                        {...a11yProps(12)}
                                    />
                                    <Tab
                                        label="Tags"
                                        {...a11yProps(13)}
                                    />
                                </Tabs>
                            </Box>

                            <CustomTabPanel value={value} index={0}>
                                <DinagraphiCards />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <FluidLevels />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={2}>
                                <Trends />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={3}>
                                {!showDetailMechanical ? (
                                    <DiagramaMecanico
                                        show={showDetailMechanical}
                                        setShowDetailMechanical={
                                            setShowDetailMechanical
                                        }
                                    />
                                ) : (
                                    <DetallesDiagramaMecanico
                                        show={showDetailMechanical}
                                        setShowDetailMechanical={
                                            setShowDetailMechanical
                                        }
                                    />
                                )}
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={4}>
                                <HistoricalActividades />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={5}>
                                <OptimizationActivities />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={6}>
                                <Box>
                                    <Requerimientos />
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={7}>
                                <SubSurfaceJobs
                                    dataToTable={subSurfaceDataTable}
                                    setdataToTable={setSubSurfaceDataTable}
                                    filteredData={[]}
                                    filters={[]}
                                />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={8}>
                                <WaterTest
                                    filteredData={[]}
                                    filters={[]}
                                />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={9}>
                                <ProductionModule />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={10}>
                                <SteamModule />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={11}>
                                <TechnicalMeetDiscussions />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={12}>
                                <FileAttachment />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={13}>
                                <Tags />
                            </CustomTabPanel>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </WrapMain>
    );
};

export default DetailsLocation;
